import {SuggestLocation} from '@yandex-delivery/api/model/suggest'

export const getGeolocationFromBrowser = (): Promise<SuggestLocation> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(({coords}) => resolve([coords.longitude, coords.latitude]), reject, {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 2000,
    })
  })

export const getGeolocationPermission = (): Promise<PermissionStatus> => {
  if (!navigator.permissions) {
    return Promise.reject()
  }

  return new Promise((resolve, reject) => {
    navigator.permissions.query({name: 'geolocation'}).then(resolve).catch(reject)
  })
}
